import React, { useState } from "react";
import api from "../api/api";
import { getPracticeId } from "../config/practice";
import { KeyGlyph } from "./userui";
import {
  PasswordChoice,
  PasswordDialog,
  PasswordReveal,
  generatePassword,
  passwordProblem,
  passwordUpdate,
} from "./PasswordFields";
import "./user.css";

/* Reset password, from the key in a Users row: the same choice as Add user,
   then the generated password to copy. */
const ResetPasswordModal = ({ user, onClose }) => {
  const practiseid = getPracticeId();
  const [mode, setMode] = useState("auto");
  const [password, setPassword] = useState("");
  const [askChange, setAskChange] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(null);

  const name = `${user?.firstname || ""} ${user?.lastname || ""}`.trim() || user?.username;
  const sub = [user?.username, user?.email].filter(Boolean).join(" · ");
  const blocked = Boolean(passwordProblem(mode, password));

  const submit = async () => {
    if (blocked || busy) return;
    const pwd = mode === "auto" ? generatePassword() : password;
    setBusy(true);
    setError("");
    try {
      const response = await api.put(`/v1/${practiseid}/user`, passwordUpdate(user, pwd, askChange));
      if (response?.status === 200) {
        setDone({ pwd, generated: mode === "auto" });
      } else {
        setError(response?.message || "The password wasn't changed. Please try again.");
      }
    } catch (e) {
      console.error(e);
      setError("The password wasn't changed. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <PasswordDialog
        icon={KeyGlyph}
        title={`Password reset for ${name}`}
        sub={sub}
        onClose={onClose}
        footer={
          <button type="button" className="bmuf-save" onClick={onClose}>
            Done
          </button>
        }
      >
        <div className="bmpw-done">
          {done.generated ? (
            <>
              <p>Copy the new password and share it with them securely. It won't be shown again.</p>
              <PasswordReveal password={done.pwd} />
            </>
          ) : (
            <p>The new password is saved. Share it with them securely.</p>
          )}
        </div>
      </PasswordDialog>
    );
  }

  return (
    <PasswordDialog
      icon={KeyGlyph}
      title={`Reset password for ${name}`}
      sub={sub}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="bmuf-cancel" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="bmuf-save" onClick={submit} disabled={blocked || busy}>
            {busy ? "Resetting…" : "Reset password"}
          </button>
        </>
      }
    >
      {error && <p className="bmuf-err">{error}</p>}
      <PasswordChoice
        mode={mode}
        setMode={setMode}
        password={password}
        setPassword={setPassword}
        askChange={askChange}
        setAskChange={setAskChange}
      />
    </PasswordDialog>
  );
};

export default ResetPasswordModal;
